export default "__VITE_PUBLIC_ASSET__74d569f0__"